import React from "react";
const Error = () => {
  return <div className="text-center">error 404!</div>;
};

export { Error };
